import React from 'react';
import { Link } from 'react-router-dom';
import CtaBand from '../../components/CtaBand';
import Seo from '../../components/Seo';
import { CORE_CITIES, hasServiceCityPage } from '../../data/cities';
import { NAV_SERVICES } from '../../data/services';
import { locationPath, ROUTES, serviceCityPath, servicePath } from '../../enum/routes';

export default function ServicesPage() {
  return (
    <>
      <Seo
        title="Remodeling Services in Texas | Epic Home Pros"
        description="Browse Epic Home Pros services - kitchen remodeling, bathroom remodeling, ADUs, decks, covered patios, pergolas, and outdoor kitchens across major Texas markets."
        path={ROUTES.SERVICES}
      />

      <section className="bg-forest-tint py-16 sm:py-24">
        <div className="container-page">
          <div className="mx-auto max-w-2xl text-center">
            <div className="label-eyebrow">What We Help With</div>
            <h1 className="h-display mt-3">Remodeling services across Texas</h1>
            <p className="mt-5 text-lg text-ink/75">
              Start with the project type that matches your home. Each service page covers process, planning ranges, and
              links to our major Texas markets.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 sm:py-20">
        <div className="container-page">
          <ul className="grid grid-cols-1 gap-6 lg:grid-cols-2">
            {NAV_SERVICES.map((service) => (
              <li
                key={service.slug}
                className="card-hover flex h-full flex-col rounded-xl border border-black/10 bg-white p-6 shadow-sm hover:border-forest/40"
              >
                <h2 className="font-serif text-2xl text-ink">{service.name}</h2>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-ink/75">{service.heroLead}</p>
                <Link
                  className="mt-5 inline-flex text-sm font-semibold text-forest hover:text-forest-hover"
                  to={servicePath(service.slug)}
                >
                  Learn more about {service.name} →
                </Link>
                <div className="mt-5 border-t border-black/5 pt-4">
                  <p className="text-xs font-semibold uppercase tracking-wider text-ink/45">Available in</p>
                  <ul className="mt-2 flex flex-wrap gap-x-3 gap-y-1">
                    {CORE_CITIES.map((city) => (
                      <li key={city.slug}>
                        <Link
                          className="text-sm font-medium text-forest hover:underline"
                          to={
                            hasServiceCityPage(service.slug, city.slug)
                              ? serviceCityPath(service.slug, city.slug)
                              : locationPath(city.slug)
                          }
                        >
                          {city.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </li>
            ))}
          </ul>
          <p className="mt-8 text-sm text-ink/70">
            Prefer to browse by market?{' '}
            <Link className="font-semibold text-forest hover:underline" to={ROUTES.SERVICE_AREAS}>
              Browse by City
            </Link>
            .
          </p>
        </div>
      </section>

      <CtaBand title="Ready to start a remodel quote?" lead="Free estimate. No obligation." />
    </>
  );
}
